import React from 'react';
import PropTypes from 'prop-types';
import { RootProvider } from '@jarvis/react-portal-addons';
import resources from '../../assets/locale/index';
import { ErrorPageContent } from './ErrorPageContent';
import GenericThemeProvider from '../../shared/GenericThemeProvider';

const ErrorPage = props => {
  const { shell, stack, properties } = props;
  const localization = shell?.localization || {};

  return (
    <RootProvider
      stack={stack}
      shell={shell}
      localization={localization}
      resources={resources}
      properties={properties}
    >
      <GenericThemeProvider>
        <ErrorPageContent />
      </GenericThemeProvider>
    </RootProvider>
  );
};

ErrorPage.propTypes = {
  shell: PropTypes.objectOf(PropTypes.any).isRequired,
  stack: PropTypes.number.isRequired,
  properties: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default ErrorPage;
